/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AncillaryManagerFormConfiguration,
    AncillaryManagerFormConfigurationFromJSON,
    AncillaryManagerFormConfigurationToJSON,
    AncillaryManagerFormData,
    AncillaryManagerFormDataFromJSON,
    AncillaryManagerFormDataToJSON,
    AncillaryManagerValidationData,
    AncillaryManagerValidationDataFromJSON,
    AncillaryManagerValidationDataToJSON,
} from '../models';

export interface ApiAncillaryManagerFormConfigurationGetRequest {
    ancillaryCategory?: number;
}

export interface ApiAncillaryManagerFormCreatePostRequest {
    ancillaryManagerFormData?: AncillaryManagerFormData;
}

export interface ApiAncillaryManagerFormDataGetRequest {
    id?: string;
}

export interface ApiAncillaryManagerFormUpdatePostRequest {
    ancillaryManagerFormData?: AncillaryManagerFormData;
}

export interface ApiAncillaryManagerFormValidatePostRequest {
    ancillaryManagerFormData?: AncillaryManagerFormData;
}

/**
 * no description
 */
export class AncillaryManagerFormApi extends runtime.BaseAPI {

    /**
     */
    async apiAncillaryManagerFormConfigurationGetRaw(requestParameters: ApiAncillaryManagerFormConfigurationGetRequest): Promise<runtime.ApiResponse<AncillaryManagerFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.ancillaryCategory !== undefined) {
            queryParameters['ancillaryCategory'] = requestParameters.ancillaryCategory;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryManagerForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AncillaryManagerFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillaryManagerFormConfigurationGet(requestParameters: ApiAncillaryManagerFormConfigurationGetRequest): Promise<AncillaryManagerFormConfiguration> {
        const response = await this.apiAncillaryManagerFormConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAncillaryManagerFormCreatePostRaw(requestParameters: ApiAncillaryManagerFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryManagerForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillaryManagerFormDataToJSON(requestParameters.ancillaryManagerFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAncillaryManagerFormCreatePost(requestParameters: ApiAncillaryManagerFormCreatePostRequest): Promise<void> {
        await this.apiAncillaryManagerFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiAncillaryManagerFormDataGetRaw(requestParameters: ApiAncillaryManagerFormDataGetRequest): Promise<runtime.ApiResponse<AncillaryManagerFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryManagerForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AncillaryManagerFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillaryManagerFormDataGet(requestParameters: ApiAncillaryManagerFormDataGetRequest): Promise<AncillaryManagerFormData> {
        const response = await this.apiAncillaryManagerFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAncillaryManagerFormUpdatePostRaw(requestParameters: ApiAncillaryManagerFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryManagerForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillaryManagerFormDataToJSON(requestParameters.ancillaryManagerFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAncillaryManagerFormUpdatePost(requestParameters: ApiAncillaryManagerFormUpdatePostRequest): Promise<void> {
        await this.apiAncillaryManagerFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiAncillaryManagerFormValidatePostRaw(requestParameters: ApiAncillaryManagerFormValidatePostRequest): Promise<runtime.ApiResponse<AncillaryManagerValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryManagerForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillaryManagerFormDataToJSON(requestParameters.ancillaryManagerFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AncillaryManagerValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillaryManagerFormValidatePost(requestParameters: ApiAncillaryManagerFormValidatePostRequest): Promise<AncillaryManagerValidationData> {
        const response = await this.apiAncillaryManagerFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
